const ALLOWED_PROTOCOLS = new Set(['http:', 'https:']);

/**
 * Returns a safe absolute http(s) URL for navigation, or null if invalid or unsafe.
 *
 * @param {unknown} raw - Untrusted URL string (e.g. from query parameters).
 * @returns {string|null} Normalized URL, or null when the value must not be used.
 */
export default function getSafeHttpUrl(raw) {
  const trimmed = String(raw ?? '').trim();
  if (!trimmed || trimmed.startsWith('//')) {
    return null;
  }

  let parsed;
  try {
    parsed = new URL(trimmed);
  } catch {
    // Invalid URL syntax
    return null;
  }

  if (!ALLOWED_PROTOCOLS.has(parsed.protocol)) {
    return null;
  }

  return parsed.href;
}
